import { Client } from "@stomp/stompjs";
import { API_URL } from "../api/http";

let client;
let isConnecting = false;
const activeSubscriptions = new Map(); // jobId -> subscription object
const pendingSubscriptions = new Map(); // jobId -> callback (waiting for connect)

const buildClient = () => {
  const baseURL = API_URL?.split("//");

  client = new Client({
    brokerURL: `wss://${baseURL[1]}/ws`,
    reconnectDelay: 5000,

    onConnect: () => {
      console.log("-------WebSocket Connected-----");
      isConnecting = false;

      // Subscribe to anything that was requested before the connection was ready
      pendingSubscriptions.forEach((callback, jobId) => {
        doSubscribe(jobId, callback);
      });
      pendingSubscriptions.clear();
    },

    onDisconnect: () => {
      console.log("WebSocket Disconnected");
      activeSubscriptions.clear();
    },

    onStompError: (frame) => {
      console.error("WebSocket Error:", frame);
    },
  });
};

const doSubscribe = (jobId, callback) => {
  if (activeSubscriptions.has(jobId)) return; // already subscribed

  const destination = `/organization/ai-status/${jobId}`;

  const subscription = client.subscribe(destination, (message) => {
    try {
      const data = JSON.parse(message?.body);
      callback(data);
    } catch (e) {
      console.error("Failed to parse WebSocket message:", e);
    }
  });

  activeSubscriptions.set(jobId, subscription);
  console.log(`Subscribed to ${destination}`);
};

export const connectSocket = () => {
  if (client?.connected || isConnecting) return;
  isConnecting = true;

  if (!client) {
    buildClient();
  }

  client.activate();
};

/**
 * Subscribe to a specific AI generation job's status updates.
 * Safe to call multiple times for different jobIds (e.g. multiple
 * concurrent generations, or multiple tabs each with their own job).
 */
export const subscribeToAiStatus = (jobId, callback) => {
  if (!jobId) {
    console.warn("subscribeToAiStatus called without a jobId");
    return;
  }

  connectSocket();

  if (client?.connected) {
    doSubscribe(jobId, callback);
  } else {
    // queue it until onConnect fires
    pendingSubscriptions.set(jobId, callback);
  }
};

/**
 * Unsubscribe from a specific job's topic once it's done (completed/errored)
 * so we don't keep listening to a dead topic forever.
 */
export const unsubscribeFromAiStatus = (jobId) => {
  const subscription = activeSubscriptions.get(jobId);
  if (subscription) {
    subscription.unsubscribe();
    activeSubscriptions.delete(jobId);
    console.log(`Unsubscribed from /topic/ai-status/${jobId}`);
  }
  pendingSubscriptions.delete(jobId);
};

export const disconnectSocket = () => {
  activeSubscriptions.forEach((sub) => sub.unsubscribe());
  activeSubscriptions.clear();
  pendingSubscriptions.clear();
  client?.deactivate();
};